import { Shift } from "../schema";
import { ukPayCalculator } from "./uk/ukPayCalculator";
import { fpPayCalculator } from "./fp/fpPayCalculator";
import { isUKTaxPayer, ShiftData } from "./common";

export const payCalculator = async (userTaxCountry: string, shifts: Shift[], month: number, year: number, country: 'UK' | 'FP', exchangeRate: number | null = null): Promise<ShiftData[]> => {
    const isUK = isUKTaxPayer(userTaxCountry);
    // Pay changed in March 2025
    const isUKAndAfterMarch2025 = isUK && (year > 2025 || (year === 2025 && month >= 3));
    if (country === 'UK') {
        return ukPayCalculator(isUKAndAfterMarch2025, shifts, month, year);
    } else if (country === 'FP') {
        return fpPayCalculator(shifts, month, year, exchangeRate);
    }
    return [];
}